import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import SimpleStepItemsTable from "../../components/simple-steps/SimpleStepItemsTable";

const SimpleStepItems = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <SimpleStepItemsTable />
        </WrapperSection>
    );
};

export default SimpleStepItems;
